import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  apiKey,
  apiPassword,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, apiPassword] as const

export type xgsiCredType = (typeof credentialTypes)[number]
export const xgsiDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const xgsi: CarrierDef<xgsiCredType> = {
  name: 'Xpress Global Systems',
  scac: 'xgsi',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['api-password', 'apiPassword'],
  ],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: xgsiDocumentTypes,
}
